<template>
  <base-edit :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template slot="email" slot-scope="{ input }">
      <div>{{input}}</div>
    </template>
  </base-edit>
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resourceName: "administrators",
      fields: [
        {
          label: "運営管理者名",
          name: "name",
          rules: "required|max:255",
          width: "60%"
        },
        {
          label: "運営管理者名（かな）",
          name: "name_kana",
          rules: "required|max:255",
          width: "60%"
        },
        {
          label: "運営管理者メールアドレス",
          name: "email",
          type: "custom",
          width: "60%"
        },
        {
          label: "全権限",
          name: "permission_all",
          type: "radio",
          textKey: "text",
          valueKey: "value",
          selects: [
            {
              text: "権限なし",
              value: 0
            },
            {
              text: "権限あり",
              value: 1
            }
          ]
        },
        {
          label: "メーカー管理権限",
          name: "permission_maker",
          type: "radio",
          textKey: "text",
          valueKey: "value",
          selects: [
            {
              text: "権限なし",
              value: 0
            },
            {
              text: "権限あり(閲覧のみ)",
              value: 1
            },
            {
              text: "権限あり(編集可)",
              value: 2
            }
          ]
        },
        {
          label: "ユーザ管理権限",
          name: "permission_user",
          type: "radio",
          textKey: "text",
          valueKey: "value",
          selects: [
            {
              text: "権限なし",
              value: 0
            },
            {
              text: "権限あり(閲覧のみ)",
              value: 1
            },
            {
              text: "権限あり(編集可)",
              value: 2
            }
          ]
        },
        {
          label: "特集記事管理権限",
          name: "permission_article",
          type: "radio",
          textKey: "text",
          valueKey: "value",
          selects: [
            {
              text: "権限なし",
              value: 0
            },
            {
              text: "権限あり(閲覧のみ)",
              value: 1
            },
            {
              text: "権限あり(編集可)",
              value: 2
            }
          ]
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "運営管理者一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "運営管理者編集",
          disabled: true
        }
      ];
    }
  }
};
</script>
